export const APP_LOCALES = ["en", "es", "fr"] as const;
export type AppLocale = (typeof APP_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export const LOCALE_COOKIE = "jorvio_locale";

export const LOCALE_LABELS: Record<AppLocale, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
};

export function normalizeAppLocale(raw: string | null | undefined): AppLocale {
  const s = (raw ?? "").trim().toLowerCase();
  if (s === "es" || s.startsWith("es")) return "es";
  if (s === "fr" || s.startsWith("fr")) return "fr";
  return "en";
}

/** BCP 47 tag for `Date#toLocaleDateString` / `Intl` (matches app languages). */
export function bcp47ForAppLocale(locale: AppLocale): string {
  if (locale === "es") return "es";
  if (locale === "fr") return "fr";
  return "en-US";
}
